import * as types from '@/store/types'

export default {
	
    [types.GET_MOFA_LAND]: (state, type) => {
    	return state.land
    },
    [types.GET_MOFA_CENTCOM]: (state, type) => {
        return state.centcom
    },
    [types.GET_MOFA_AIR]: (state, type) => {
    	return state.air
    },
    [types.GET_MOFA_TEMP]: (state, type) => {
        return state.temp
    },
    [types.GET_MOFA_NSL]: (state, type) => {
    	return state.nsl    
    },
    [types.GET_MOFA_SEA]: (state, type) => {
    	return state.sea    
    }

}


// WEBPACK FOOTER //
// ./src/store/modules/mofa/getters.js